enum EnvironmentNames {
  PROD = 'prod',
  QA = 'qa',
  DEV = 'dev',
  LOCAL = 'local',
}

export default EnvironmentNames;
